import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import deliveriesIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import {
  getProductDeliveries,
  createSystemBoundaryProductDelivery,
} from "../../../../../apis/Product/ProductDeliveriesApi";

const DeliveriesIcon = () => (
  <img src={deliveriesIcon} alt="Deliveries Icon" width={76} height={76} />
);

const ProdDeliveriesHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState([]);
  const [systemBoundaryItem, setSystemBoundaryItem] = useState("");

  useEffect(() => {
    getProductDeliveries({
      id: productId,
      setProdInv: setTotalProdItem,
      setSystemBoundary: setSystemBoundaryItem,
    });
  }, [productId]);
  return (
    <CategoryComponent
      show={show}
      className={`prod-transport-category ${className || ""}`}
      leftBoxProps={{
        icon: <DeliveriesIcon />,
        title: t("PROD_TRANSPORT"),
        productId: productId,
        isSystemBoundary: true,
        systemBoundary: systemBoundaryItem,
        setSystemBoundary: setSystemBoundaryItem,
        createSystemBoundaryFunc: createSystemBoundaryProductDelivery,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalProdItem
                        ? handleToFixedNum(
                            totalProdItem,
                            totalProdItem?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default ProdDeliveriesHeader;
